<template>
    <div class="pc-home">
        <div class="main">
            <div class="main-left">
                <div class="main-text">
                    <div class="main-text-top">Welcome</div>
                    <div class="main-text-middle">To TOM</div>
                    <div class="main-text-bottom"></div>
                </div>
                <div class="main-icon">
                    <img class="main-img" src="data:image/jpeg;base64,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"/>
                </div>
            </div>
            <div class="main-middle">
                <img class="main-middle-img" src="../assets/rightArrows.png">
            </div>
            <div class="main-right">
                <div class="content-right">
                  <div class="right-website" >
                    <div v-for="item in webSitList" :key="item" class="right-website-content">
                      {{item.name}}：<a :href="item.url" target="_blank">{{item.url}}</a>
                    </div>
                  </div>
                  <div class="right-middle">
                    <img class="right-middle-img" src="../assets/temp.jpg">
                  </div>
                  <div class="right-font">
                    <div class="right-font-left"></div>
                    <div class="right-font-middle">微信小程序搜索: 一万小时记录</div>
                    <div class="right-font-right"></div>
                  </div>
                </div>
            </div>
        </div>
        <div class="put-on-records"><a class="beian" href="http://beian.miit.gov.cn">ICP证:浙ICP备19031102号</a></div>
    </div>
</template>

<script>
    export default {
        name: "PcHome",
      data() {
        return {
          secret:"wbh",
          inputSecret:"",
          openSecret:false,
          webSitList:[
            {
              name:"博客",
              url:"https://blog.tomtangmu.com"
            }
          ],
          myselfWebSitList:[
            {
              name:"密码",
              url:"https://bitwarden.tomtangmu.com"
            },
            {
              name:"freshrss",
              url:"https://freshrss.tomtangmu.com"
            },
            {
              name:"bt",
              url:"https://bt.tomtangmu.com"
            },
            {
              name:"短链接",
              url:"https://link.tomtangmu.com/admin"
            },
            {
              name:"nexus",
              url:"https://nexus.tomtangmu.com"
            },
            {
              name:"portainer",
              url:"https://portainer.tomtangmu.com"
            },
            {
              name:"rsshub",
              url:"https://rsshub.tomtangmu.com"
            },
            {
              name:"监控",
              url:"https://netdata.tomtangmu.com"
            },
            {
              name:"统计",
              url:"https://matomo.tomtangmu.com"
            },
          ]
        }
      },

      created(){
        this.keyDown()
      },
      methods:{
        keyDown(){
          document.onkeydown = (e)=>{
            let key = e.key;
            this.inputSecret=this.inputSecret+key;
            if (this.secret.indexOf(this.inputSecret)>-1){
              if (this.inputSecret == this.secret){
                if (!this.openSecret){
                  this.openSecret=true;
                  this.webSitList=this.webSitList.concat(this.myselfWebSitList)
                }
              }
            }else {
              this.inputSecret="";
            }
          };
        }
      },
    }
</script>

<style scoped>
    .pc-home {
        /*margin: 0px;*/
        width: 100vw;
        /*width: 1920px;*/
        height: 100vh;
        /*height: 1080px;*/
        background-image: url("../assets/background.png");
        background-size:100% 100%;
        background-attachment:fixed;
        /*background-color: forestgreen;*/
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        /*opacity: 0.29;*/
        overflow-y: hidden;
    }
    .main{
        z-index: 100;
        width: 67.14vw;
        height: 57.78vh;
        margin-left: 11.51vw;
        margin-top: 22.31vh;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
    }
    .main-left{
        width: 38.59vw;
        height: 45.19vh;
        border-bottom-left-radius: 22.59vh;
        border-top-left-radius: 22.59vh;
        background: linear-gradient(180deg, #1D5A5E 0%, #1E5B5F 100%);
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        margin-top: 6.3vh;
    }
    .main-text{
        margin-left: 3.12vw;
        margin-top: 16.27vh;
        width: 13.28vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        text-align: left;
    }
    .main-text-top{
        width: 13.28vw;
        height: 3.13vh;
        font-size: 40px;
        font-family: PangMenZhengDao;
        color: #FFFFFF;
        /*line-height: 42px;*/
    }
    .main-text-middle{
        width: 14.35vw;
        height: 3.13vh;
        font-size: 30px;
        font-family: PangMenZhengDao;
        color: #FFFFFF;
        /*line-height: 42px;*/
        margin-top: 3.67vh;
    }
    .main-text-bottom{
        width: 4.17vw;
        height: 0.55vh;
        background: #FFFFFF;
        border-radius: 3px;
        margin-top: 3.67vh;
    }
    .main-icon{
        width: 14.37vw;
        height: 25.55vh;
        margin-top: 9.81vh;
        margin-left: 1.53vw;
    }
    .main-img{
        /*margin-left:40%;*/
        /*margin-top:5%;*/
        width:100%;
        height:100%;
        border-radius: 50%;
    }
    .main-middle{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 4.58vw;
        height: 8.14vh;
        margin-top: 11vh;
        margin-left: -7.3vw;
    }
    .main-middle-img{
        width: 4.58vw;
        height: 8.14vh;
    }
    .main-right{
        width: 38.59vw;
        height: 57.78vh;
        border-bottom-right-radius: 312px;
        border-top-right-radius: 312px;
        background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
    }
    .content-right{
      height: 47.78vh;
      margin-left: 5.8vw;
      margin-top: 5vh;
      text-align: left;
    }
    .right-website{
      color: rgb(29, 90, 94);
      font-size: 16px;
      font-family: PangMenZhengDao;
      height:  30vh;
      overflow-y: auto;
    }
    .right-website > a{
      background-color: rgb(29, 90, 94);
    }
    .right-website-content{
      margin-top: 2vh;
    }
    .right-middle{
      width: 7.8vw;
      height: 13.9vh;
      margin-left: 4vw;
      margin-top: 1.5vh;
    }
    .right-middle-img{
      width: 7.8vw;
      height: 13.9vh;
      border-radius: 50%;
    }
    .right-font{
      margin-top: 2vh;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
    }
    .right-font-left{
      width: 2.17vw;
      height: 0.25vh;
      background: rgb(29, 90, 94);
      border-radius: 3px;
      margin-top: 1vh;
    }
    .right-font-middle{
      color:  rgb(29, 90, 94);
    }
    .right-font-right{
      width: 2.17vw;
      height: 0.25vh;
      background: rgb(29, 90, 94);
      border-radius: 3px;
      margin-top: 1vh;
    }
    .put-on-records{
        position:absolute;
        bottom:5%;
        text-align:center;
        margin-left:30%;
        width:40%;
    }
    .beian{
        color:#FFFFFF;
    }
</style>
